/* eslint curly:0 */

import joinURL from './joinURL.js'

const isAddress = str => /^(https?:)?\/\//.test(str)

export default function getFullRjsConfig(name, base, config, packagesUtil, serviceTopology) {
  function getBaseUrl() {
    if (!base) return serviceTopology.scriptsLocationMap[name]
    if (isAddress(base)) return base
    return joinURL(serviceTopology.scriptsDomainUrl, 'services', name, base)
  }

  config = packagesUtil.buildConfig(config)
  config.baseUrl = getBaseUrl()
  return config
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/getFullRjsConfig.js